// src/lib/useIsMobile.js
// Tiny responsive hook used across agent pages so we can swap layouts
// (tables → cards, two-pane → single-pane, multi-col → stacked) when
// the viewport narrows. Default breakpoint matches AgentLayout's
// (900px) so the topbar/sidebar drawer and page layouts switch in
// sync.
import { useEffect, useState } from 'react';

export function useIsMobile(breakpoint = 900) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);
  return isMobile;
}
